module.exports = __webpack_public_path__ + "media/images/emblems/Zeiningen-blason-92e70a314969a743dd24cf5b326669e0.png";